document.addEventListener('DOMContentLoaded', function () {
    const tabsContainer = document.querySelector('.wp-block-atbs-tabs');

    if (!tabsContainer) return;

    const tabsTitles = tabsContainer.querySelectorAll('.tab-title');
    const tabsContents = tabsContainer.querySelectorAll('.single-tab');

    function activateTab(tabId) {
        console.log('activatetab', tabId);

        if (!tabId) return;

        tabsTitles.forEach(tab => tab.classList.remove('active'));
        tabsContents.forEach(content => {
            content.classList.remove('active');
            content.style.display = 'none';
        });

        const targetTab = tabsContainer.querySelector(`.tab-title[data-title-tab-id="${tabId}"]`);
        const targetContent = tabsContainer.querySelector(`.single-tab[data-tab-id="${tabId}"]`);

        console.log({ targetTab, targetContent });

        if (targetTab) targetTab.classList.add('active');
        if (targetContent) {
            targetContent.classList.add('active');
            targetContent.style.display = 'block';
        }
    }

    function initializeTabFromHash() {
        const hash = window.location.hash;
        console.log(hash);
        if (hash.startsWith('#tab')) {
            const tabId = hash.replace('#tab', '');
            activateTab(tabId);
        }

        addClickListeners();
    }

    function addClickListeners() {
        tabsTitles.forEach(tab => {
            tab.addEventListener('click', function () {
                const tabId = this.getAttribute('data-title-tab-id');
                if (tabId) {
                    if (window.location.hash !== `#tab${tabId}`) {
                        window.location.hash = `#tab${tabId}`; // Atualiza o hash
                    }
                }
            });
        });
    }

    setTimeout(() => {
        initializeTabFromHash();
    }, 120);
});
